import { render, staticRenderFns } from "./ModalQkmsg.vue?vue&type=template&id=1edbaa94&"
import script from "./ModalQkmsg.vue?vue&type=script&lang=js&"
export * from "./ModalQkmsg.vue?vue&type=script&lang=js&"
import style0 from "./ModalQkmsg.vue?vue&type=style&index=0&id=1edbaa94&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports